import React from 'react'
import { Box, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress, Grid, Divider } from '@mui/material'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import { useQuery } from '@tanstack/react-query';
import { getNpoGovernanceDetails } from '../../../Store/npoProfile/npoProfile';
import Loading from '../../../Components/Loader/Loading';
import dayjs from 'dayjs';

export default function Governance({ orgName, id }) {

  const { data: governanceDetails, isPending: governanceDetailsLoading } = useQuery({
    queryKey: ['governanceDetails', orgName],
    queryFn: () => getNpoGovernanceDetails(orgName),
    refetchOnWindowFocus: false,
    enabled: !!orgName
  });



  const formatDisplayDate = (dateString) => {
    if (!dateString) return '-';
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) return dateString;
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
      const [day, month, year] = dateString.split('-');
      return `${day}/${month}/${year}`;
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      const [year, month, day] = dateString.split('-');
      return `${day}/${month}/${year}`;
    }
    const parsed = dayjs(dateString);
    return parsed.isValid() ? parsed.format('DD/MM/YYYY') : dateString;
  };

  return (
    <>
      <div id={id} >
        <Divider sx={{ color: '#E5E8EB', marginTop: '25px', borderBottomWidth: 3 }} />
        {governanceDetailsLoading ? <Box sx={{ mt: 5, px: 4, display: 'flex', justifyContent: 'center' }}><Loading /></Box> : <Box sx={{ mt: 3 }}>
          <Grid container spacing={2} sx={{ mt: .5 }}>
            <Grid item xs={12} md={6} lg={6}>
              <Box sx={{ backgroundColor: '#004878', padding: '10px', borderRadius: '15px', width: '100%', display: 'flex', alignItems: 'center' }}>
                <ParagraphComp text='Governance' className='text-[white] mt-[0px] mb-[0px] text-2xl  font-bold' />
              </Box>
            </Grid>


          </Grid>
          {(governanceDetails?.body_members && governanceDetails?.body_members?.length > 0) ||
            governanceDetails?.board_practices?.[0]?.ethics_and_transparency ||
            governanceDetails?.board_practices?.[0]?.minutes_of_meeting ||
            governanceDetails?.board_practices?.[0]?.board_rotationgovernanceDetails?.board_practices?.[0]?.meeting_date1 ||
            governanceDetails?.board_practices?.[0]?.meeting_date2 || governanceDetails?.board_practices?.[0]?.meeting_date3 ?
            <>
              <Grid container spacing={2} sx={{ mt: .5 }}>
                <Grid item xs={12} md={6} lg={6}>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <ParagraphComp text='Last updated on:' className='text-[black] italic font-thin' />
                </Grid>
              </Grid>
              {governanceDetails?.body_members && governanceDetails?.body_members?.length > 0 ?
                <>
                  <ParagraphComp text='Governing Body Members' className='text-[#004878] mt-[30px] text-2xl mb-3 font-bold' />
                  <ParagraphComp text='ˇ SOURCE: Self-reported by organisation ' className='text-[black] text-md mb-[10px] italic font-thin' />
                  <div className="w-full overflow-x-auto">
                    <Table aria-label="collapsible table" className="min-w-[1200px]">
                      <TableHead sx={{ background: '#EDF2F6' }}>
                        <TableRow>
                          <TableCell sx={{ color: '#004878', fontSize: '16px', fontWeight: 600 }} align="left">Name</TableCell>
                          <TableCell sx={{ color: '#004878', fontSize: '16px', fontWeight: 600 }} align="left" width={90}>Gender</TableCell>
                          <TableCell sx={{ color: '#004878', fontSize: '16px', fontWeight: 600 }} align="left" width={90}>Age</TableCell>
                          <TableCell sx={{ color: '#004878', fontSize: '16px', fontWeight: 600 }} align="left">Position on the board</TableCell>
                          <TableCell sx={{ color: '#004878', fontSize: '16px', fontWeight: 600 }} align="left">Operational role in the Org</TableCell>
                          <TableCell sx={{ color: '#004878', fontSize: '16px', fontWeight: 600 }} align="left">Occupation</TableCell>
                          <TableCell sx={{ color: '#004878', fontSize: '16px', fontWeight: 600 }} align="left">Related to</TableCell>
                          <TableCell sx={{ color: '#004878', fontSize: '16px', fontWeight: 600 }} align="left" width={108}>Remunerated </TableCell>
                          <TableCell sx={{ color: '#004878', fontSize: '16px', fontWeight: 600 }} align="left" width={158}>Interested party payments</TableCell>
                          <TableCell sx={{ color: '#004878', fontSize: '16px', fontWeight: 600 }} align="left" width={158}>Date of current appointment to the board</TableCell>
                          <TableCell sx={{ color: '#004878', fontSize: '16px', fontWeight: 600 }} align="left" width={158}>Area of Expertise</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(governanceDetails?.body_members && governanceDetails?.body_members?.length > 0) ? governanceDetails?.body_members?.map((item, index) =>
                          <TableRow key={index}>
                            <TableCell sx={{ fontSize: '16px' }} align="left">{item?.name}</TableCell>
                            <TableCell sx={{ fontSize: '16px' }} align="left">{item?.gender}</TableCell>
                            <TableCell sx={{ fontSize: '16px' }} align="left">{item?.age}</TableCell>
                            <TableCell sx={{ fontSize: '16px' }} align="left">{item?.position}</TableCell>
                            <TableCell sx={{ fontSize: '16px' }} align="left">{item?.oprational_role}</TableCell>
                            <TableCell sx={{ fontSize: '16px' }} align="left">{item?.occupation}</TableCell>
                            <TableCell sx={{ fontSize: '16px' }} align="left">{item?.related_to}</TableCell>
                            <TableCell sx={{ fontSize: '16px' }} align="left">{(item?.remunerated1 || item?.remunerated2) ? `${(item?.remunerated1 != 'No' || item?.remunerated2 != 'No') ? 'Yes' : 'No'}` : ''}</TableCell>
                            <TableCell sx={{ fontSize: '16px' }} align="left">{item?.party_payments}</TableCell>
                            <TableCell sx={{ fontSize: '16px' }} align="left">{formatDisplayDate(item?.appointment_date)?.replace(/\//g, '-')}</TableCell>
                            <TableCell sx={{ fontSize: '16px' }} align="left">{item?.area_of_competency}</TableCell>
                          </TableRow>) : ''}
                      </TableBody>
                    </Table>
                  </div>

                </>
                : ''
              }
              {governanceDetails?.board_practices?.[0]?.ethics_and_transparency || governanceDetails?.board_practices?.[0]?.minutes_of_meeting || governanceDetails?.board_practices?.[0]?.board_rotation ?
                <Box sx={{ mt: 3 }}>
                  <ParagraphComp text='Governing Board Leadership Practices in FY YYYY-YY' className='text-[#004878] text-2xl mb-3 font-bold' />
                  <ParagraphComp text='ˇ SOURCE: Self-reported by organisation ' className='text-[black] text-md mb-[10px] italic font-thin' />
                  <Grid container spacing={2}>
                    <Grid item lg={4} md={4} xs={6}>
                      <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', }}>
                        <Box>
                          <ParagraphComp text='Ethics and Transparency' className='text-[#004878] text-md font-bold w-40' />
                          <ParagraphComp text={governanceDetails?.board_practices?.[0]?.ethics_and_transparency || '-'} className='text-[#004878] text-md font-normal' />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item lg={4} md={4} xs={6}>
                      <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', }}>
                        <Box>
                          <ParagraphComp text='Minutes of the Board meeting' className='text-[#004878] text-md font-bold w-40' />
                          <ParagraphComp text={governanceDetails?.board_practices?.[0]?.minutes_of_meeting || '-'} className='text-[#004878] text-md font-normal' />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item lg={4} md={4} xs={6}>
                      <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', }}>
                        <Box >
                          <ParagraphComp text='Board Rotation Policy' className='text-[#004878] text-md font-bold w-40' />
                          <ParagraphComp text={governanceDetails?.board_practices?.[0]?.board_rotation || '-'} className='text-[#004878] text-md font-normal' />
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                : ''
              }
              {governanceDetails?.board_practices?.[0]?.meeting_date1 || governanceDetails?.board_practices?.[0]?.meeting_date2 || governanceDetails?.board_practices?.[0]?.meeting_date3 ?
                <Box sx={{ mt: 3 }}>
                  <ParagraphComp text='Board meeting dates in FY  YYYY-YY' className='text-[#004878] text-2xl mb-3 font-bold' />
                  <Grid container spacing={2}>
                    <Grid item lg={4} md={4} xs={6}>
                      <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', }}>
                        <ParagraphComp text={formatDisplayDate(governanceDetails?.board_practices?.[0]?.meeting_date1)} className='text-[#004878] text-md mt-1' />
                      </Box>
                    </Grid>
                    <Grid item lg={4} md={4} xs={6}>
                      <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', }}>
                        <ParagraphComp text={formatDisplayDate(governanceDetails?.board_practices?.[0]?.meeting_date2)} className='text-[#004878] text-md mt-1' />
                      </Box>
                    </Grid>
                    <Grid item lg={4} md={4} xs={6}>
                      <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', }}>
                        <ParagraphComp text={formatDisplayDate(governanceDetails?.board_practices?.[0]?.meeting_date3)} className='text-[#004878] text-md mt-1' />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                : ''
              }
            </>
            :
            <ParagraphComp text='No data provided for this section.' className='text-[black] text-xl mt-[20px] font-thin' />
          }
        </Box>
        }
      </div >
    </>
  )
}
